import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_KIND,
  TEXT_DISPLAY,
} from '@gc-npm/components.text';
import CustomLink from '@gc-npm/components.custom-link';
import Button, { BUTTON_TYPE_HTML, BUTTON_WIDTH, BUTTON_TYPE } from '@gc-npm/components.button';

import CheckBox from '@/components/CheckBox';

const COMPONENT_NAME = 'LegalsModalForm';

const LegalsModalForm = ({
  legalText,
  legalErrorText,
  legalLinkText,
  urlLegal,
  onClickLegal,
  formSkeletonProps,
  onSubmit,
  acceptText,
  cancelText,
  subject,
  componentProduct,
}) => {
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);

  const { validateForm } = { ...formSkeletonProps };

  const recaptcha = useSelector((state) => state.UI.recaptcha);

  const LegalsModalFormTaggingInfo = {
    componentName: COMPONENT_NAME,
    componentVariation: '',
    componentContent: subject || '',
    componentProduct: componentProduct || '',
  };

  useEffect(() => {
    if (validateForm && onSubmit && recaptcha) {
      onSubmit(true);
    }
  }, [recaptcha, onSubmit, validateForm]);


  if (
    !legalText
    || !legalLinkText
    || (!urlLegal && !onClickLegal)
  ) {
    return null;
  }

  return (
    <>
      <div className="LegalsModalForm">
        {legalLinkText && (urlLegal || onClickLegal) && legalText && (
          <div className="LegalsModalForm-legal">
            <CheckBox
              name="legalCheckBox"
              formSkeletonProps={formSkeletonProps}
              taggingInfo={{
                ...LegalsModalFormTaggingInfo,
              }}
              required
              checked={checkBoxChecked}
              onChange={(e) => {
                setCheckBoxChecked(!checkBoxChecked);
              }}
              errorMsg={legalErrorText}
            />
            <div className="LegalsModalForm-legal_info">
              <CustomLink
                ariaLabel={legalText}
                onClick={() => {
                  setCheckBoxChecked(!checkBoxChecked);
                }}
                taggingInfo={{
                  ...LegalsModalFormTaggingInfo,
                  componentContent: `${legalText}-${subject || ''}`,
                }}
                forceExternal
              >
                <TextInfo
                  kind={TEXT_KIND.PARAGRAPH}
                  text={legalText}
                  color={TEXT_COLOR.GREY6}
                  size={TEXT_SIZE.BODY2}
                  align={TEXT_ALIGN.CENTER}
                  display={TEXT_DISPLAY.INLINE}
                  className="inlineText"
                />
              </CustomLink>
              <CustomLink
                ariaLabel={legalLinkText}
                href={urlLegal}
                onClick={onClickLegal}
                taggingInfo={{
                  ...LegalsModalFormTaggingInfo,
                  componentContent: `${legalLinkText}-${subject || ''}`,
                }}
                forceExternal
                target="_blank"
              >
                <TextInfo
                  kind={TEXT_KIND.PARAGRAPH}
                  text={legalLinkText}
                  color={TEXT_COLOR.MOVISTAR_BLUE}
                  size={TEXT_SIZE.BODY2}
                  align={TEXT_ALIGN.CENTER}
                  display={TEXT_DISPLAY.INLINE}
                />
              </CustomLink>
            </div>
          </div>
        )}
        <div className="LegalsModalForm-button-container">
          {acceptText && (
            <Button
              label={acceptText}
              buttonTypeHtml={BUTTON_TYPE_HTML.SUBMIT}
              width={BUTTON_WIDTH.MEDIUM}
              // disabled={!activatePurchaseButton}
              taggingInfo={{
                ...LegalsModalFormTaggingInfo,
                componentContent: `${acceptText}-${subject || ''}`,
              }}
            />
          )}
          {cancelText && (
            <Button
              label={cancelText}
              type={BUTTON_TYPE.SECONDARY}
              onClick={() => { onSubmit()}}
              taggingInfo={{
                ...LegalsModalFormTaggingInfo,
                componentContent: `${cancelText}-${subject}`,
              }}
              forceExternal
            />
          )}
        </div>
      </div>
      <style jsx>
        {`
            .LegalsModalForm {
              display: flex;
              flex-direction: column;
              gap: 1.5rem;
                &-button-container{
                    display: flex;     
                    gap: 1rem;
                }
                &-legal {
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    gap: 0.5rem;
                    align-items: flex-end;
                    &_info {
                        display: inline;
                        gap: 0.2rem;
                        :global(.inlineText) {
                          padding-right: 4px;
                        }
                    }
                }
                @media (max-width: 768px) {
                    .LegalsModalForm {
                        &-button-container {
                            flex-direction: column;
                            gap: 0.5rem;
                        }
                        &-legal {
                            display: flex;
                            align-items: center;
                            justify-content: left;
                            gap: 0.5rem;
                            margin-bottom: 1rem;    

                            &_info {
                                gap: 0rem;
                                flex-direction: column;
                                justify-content: flex-start;
                                align-items: flex-start;
                            }
                        }
                    }
                }
            }
        `}
      </style>
    </>
  );
};

export default LegalsModalForm;
